import { useTypePosition } from '../context'
import { actionTypes } from '../types'
import SnackbarState from '../types/SnackbarState'
import { TypePosition } from '../types/TypePosition'
/*
Copyright 2022-11-18 por alfonso moya Ecomsur Holding S.A ©
Detalle: Se agregan typePositionActions
*/

const typePositionActions = () => {
  const {
    state: { searchFields }
  } = useTypePosition()
  const setLoading = (loading: boolean): actionTypes => ({
    type: 'setLoading',
    payload: loading
  })

  const setRows = (rows: TypePosition[]): actionTypes => ({
    type: 'SET_ROWS',
    payload: rows
  })

  const changePage = (page: number): actionTypes => ({
    type: 'CHANGE_PAGE',
    payload: page
  })

  const changePageSize = (pageSize: number): actionTypes => ({
    type: 'CHANGE_PAGE_SIZE',
    payload: pageSize
  })

  const setTotalItems = (totalItems: number): actionTypes => ({
    type: 'SET_TOTAL_ITEMS',
    payload: totalItems
  })

  const setEditModalState = (editModalState: {
    open: boolean
    typePositionId: number
  }): actionTypes => ({
    type: 'SWITCH_EDIT_MODAL',
    payload: editModalState
  })

  const setSelectedTypePosition = (
    typePosition: TypePosition | undefined
  ): actionTypes => ({
    type: 'SELECTED_TYPE_POSITION',
    payload: typePosition
  })

  const setSearch = (field: string, value: string): actionTypes => ({
    type: 'SET_SEARCH_FIELDS',
    payload: {
      ...searchFields,
      [field]: value
    }
  })

  // Snackbar State
  const setSnackbarState = (snackbarState: SnackbarState): actionTypes => ({
    type: 'setSnackbarState',
    payload: snackbarState
  })

  return {
    setLoading,
    setRows,
    changePage,
    changePageSize,
    setTotalItems,
    setEditModalState,
    setSelectedTypePosition,
    setSearch,
    setSnackbarState
  }
}

export default typePositionActions
